var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hose",
    d: "M15.1919 1.08762L1.77884 7.81423C0.639101 8.3841 7.24792e-05 9.54843 7.24792e-05 10.8229V20.566C7.24792e-05 22.4572 1.52512 22.396 2.28764 22.1291L6.72668 20.2929C10.09 18.9003 13.3755 15.2019 13.3755 10.8229C13.3755 10.409 13.1987 10.0222 13.0621 9.65648L18.1703 7.10478C19.8322 6.27384 20.5156 4.25375 19.6846 2.59186C18.8537 0.931649 16.8572 0.253315 15.1919 1.08762Z",
    fill: "#47B4E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHose);
export default __webpack_public_path__ + "static/media/hose.582c8d2efb97be75834f8ebd25243d31.svg";
export { ForwardRef as ReactComponent };